/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { LogModel } from '../../../Admin/AdminLogs/models';

export interface LogState {
  list: LogModel[];
  continuationToken: string;
}

const initialState: LogState = {
  list: [],
  continuationToken: '',
};

export const logListSlice = createSlice({
  name: 'logList',
  initialState,
  reducers: {
    setCurrentLog: (state, { payload }) => {
      state.list = payload.list;
      state.continuationToken = payload.continuationToken;
    },
  },
  extraReducers: () => {},
});

export const { setCurrentLog } = logListSlice.actions;
export const logSelector = (state: RootState) => state.logList;
